import { useEffect, useState } from 'react';
import { trackPhoneCall } from '@/lib/gtag';

interface ExitDiscountModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ExitDiscountModal: React.FC<ExitDiscountModalProps> = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Pequeno delay para animação suave
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4 transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={onClose}
    >
      <div 
        className={`bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative transform transition-all duration-300 ${
          isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Botão fechar */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-3xl leading-none transition-colors"
          aria-label="Fechar"
        >
          ×
        </button>

        {/* Conteúdo */}
        <div className="text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl p-4 mb-4">
            <h2 className="text-3xl font-bold mb-2">🎉 15% DE DESCONTO!</h2>
          </div>
          
          <p className="text-gray-700 text-lg mb-4 font-medium">
            Não saia ainda! Você ganhou <span className="text-blue-600 font-bold">15% de desconto</span> em todos os nossos serviços!
          </p>
          
          <div className="bg-gray-50 rounded-lg p-4 mb-4 border-2 border-blue-200">
            <p className="text-sm text-gray-600 mb-2">Use o código de desconto:</p>
            <p className="text-2xl font-bold text-blue-600 tracking-wider">WS12</p>
          </div>
          
          <p className="text-gray-600 text-sm mb-4">
            Envie o formulário ou ligue e informe o código de desconto <span className="font-semibold">WS12</span>
          </p>
          
          <div className="flex flex-col gap-3">
            <a
              href="#orcamento"
              onClick={onClose}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors text-center"
            >
              Preencher Formulário
            </a>
            <a
              href="tel:+351934631520"
              onClick={() => {
                onClose();
                trackPhoneCall('+351934631520');
              }}
              className="bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-6 rounded-lg transition-colors text-center"
            >
              Ligar Agora: 960 488 777
            </a>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-sm py-2 transition-colors"
            >
              Continuar Navegando
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitDiscountModal;
